import React from "react";

const PlusIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
    >
      <path
        d="M7.6948 3.56407C7.49365 3.63828 7.33742 3.76717 7.22806 3.94684C7.09916 4.15971 7.10112 4.12456 7.10112 5.8646C7.10112 6.98753 7.09526 7.45427 7.07964 7.50114C7.03667 7.62222 7.0894 7.61832 5.35131 7.61832C3.6054 7.61832 3.64446 7.61636 3.42769 7.74721C3.15233 7.91321 3 8.18661 3 8.51666C3 8.8467 3.15233 9.12011 3.42769 9.2861C3.64446 9.41695 3.6054 9.415 5.3474 9.415C6.47033 9.415 6.93707 9.42086 6.98394 9.43648C7.10502 9.47944 7.10112 9.42671 7.10112 11.1648C7.10112 12.9107 7.09916 12.8717 7.23001 13.0884C7.39601 13.3638 7.66941 13.5161 7.99946 13.5161C8.3295 13.5161 8.60291 13.3638 8.7689 13.0884C8.89975 12.8717 8.8978 12.9107 8.8978 11.1648C8.8978 9.42671 8.89389 9.47944 9.01497 9.43648C9.06184 9.42086 9.52859 9.415 10.6515 9.415C12.3935 9.415 12.3545 9.41695 12.5712 9.2861C12.8466 9.12011 12.9989 8.8467 12.9989 8.51666C12.9989 8.18661 12.8466 7.91321 12.5712 7.74721C12.3545 7.61636 12.3935 7.61832 10.6515 7.61832C9.52859 7.61832 9.06184 7.61246 9.01497 7.59683C8.89389 7.55387 8.8978 7.6066 8.8978 5.86851C8.8978 4.1226 8.89975 4.16166 8.7689 3.94489C8.65759 3.76131 8.49159 3.62852 8.28068 3.55626C8.12054 3.49962 7.85494 3.50353 7.6948 3.56407Z"
        fill={color}
      />
    </svg>
  );
};

export default PlusIcon;
